var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticStyle:{"height":"100%","overflow":"hidden"}},[_c('vue-flux',{ref:"slider",attrs:{"options":_vm.fluxOptions,"images":_vm.fluxImages,"transitions":_vm.fluxTransitions,"width":"100%","height":"100%","type":"relative"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }